import { render, staticRenderFns } from "./AppRetrieveOldEmailConfirmation.vue?vue&type=template&id=348870b1&scoped=true&"
import script from "./AppRetrieveOldEmailConfirmation.vue?vue&type=script&lang=ts&"
export * from "./AppRetrieveOldEmailConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./AppRetrieveOldEmailConfirmation.vue?vue&type=style&index=0&id=348870b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348870b1",
  null
  
)

export default component.exports